<style src="./IsClosedTask.scss" lang="scss"></style>
<template>
  <section
    v-if="!isOpened"
    class="is-task-closed">
    <section
      v-if="isOpened === null"
      class="loading">
      Carregando informações...
    </section>

    <section
      v-if="isOpened === false"
      class="formopen">
      <span class="title">Tarefa bloqueada</span>
      <span class="description">Para interagir com essa tarefa é necessário abri-la</span>
      <button
        class="btn btn-default"
        @click="openTask">
        Abrir Tarefa
      </button>
    </section>
  </section>
</template>

<script>
export default {
  name: 'IsClosedTask',
  props: {
    stageId: {
      default: null
    },
    eventId: {
      default: null
    }
  },
  data () {
    return {
      isOpened: null
    }
  },
  mounted () {
    this.loadStageStatus()
  },
  methods: {
    async openTask () {
      const payload = {
        stageId: this.stageId,
        eventId: this.eventId
      }
      const open = await this.$store.dispatch('Board/OPEN_TASK', payload)
      if (open._id) {
        this.isOpened = true
        this.$emit('input', true)
      }
    },
    async loadStageStatus () {
      const payload = {
        stageId: this.stageId,
        eventId: this.eventId
      }
      const taskDetail = await this.$store.dispatch('Board/GET_TASK_DETAILS', payload)
      this.isOpened = taskDetail.isOpened
      this.$emit('input', taskDetail.isOpened)
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/foundation/is-closed-task/IsClosedTask.vue